
import React, { useEffect, useState } from 'react';
import styles from './_email-preferences-page.module.scss';
import { useParams } from 'react-router';
import { EmailInput } from '@amsanalytics/react-shared-library';
import { setClient, unsubscribeFromEmails } from '../../../Store/Shared/actions';
import {  useSelector } from 'react-redux';
import { Button } from '@progress/kendo-react-buttons';
import { AppState } from '../../../Store/rootReducer';
import { Typography } from '@mui/material';
import MessageViewer from '../../Controls/MessageViewer/MessageViewer';
import { useAppDispatch } from '../../../Store/useAppDispatch';



export interface EmailPreferencesPageProps {

}

export default function EmailPreferencesPage(props: EmailPreferencesPageProps) {
  const [emailAddress, setEmailAddress] = useState();
  const clientId = useSelector((appState: AppState) => appState.shared.clientId);
  const emailUnsubscribed = useSelector((appState: AppState) => appState.shared.emailUnsubscribed);
  const dispatch = useAppDispatch();
  const params = useParams();
  useEffect(() => {
    const clientId = (params as any)?.clientId;
    const email = (params as any)?.emailAddress;
    if (clientId && email) {
      setEmailAddress(email);
      dispatch(setClient(clientId));
    }
  }, [params]);
  return (
    <>
      {emailUnsubscribed
        ? <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="h4">You have been unsubscribed. You will no longer receive email notifications.</Typography>
        </div>
        : <div className={styles.emailPreferencesPageContainer}>
          <Typography className={styles.header} variant='h5'>Unsubscribe from all email notifications</Typography>
          <Typography variant='body1' style={{ marginTop: '20px', fontWeight: 'bold', marginBottom: '10px' }}>{emailAddress}</Typography>
          {clientId && (
            <Button
              style={{ width: '300px', background: '#097fdecf', border: 'none', color: 'white' }}
              type={'submit'}
              disabled={!emailAddress || emailAddress === ''}
              onClick={() => {
                dispatch(unsubscribeFromEmails(clientId, emailAddress!));
              }}
            >
              Unsubscribe
            </Button>
          )}
        </div>
      }
      <MessageViewer />
    </>

  );
}
